import { motion } from "framer-motion";
import { HERO } from "@/data/content";
import { HeroWorld } from "@/components/world/HeroWorld";
import { GhostButton, PrimaryButton } from "@/components/site/Buttons";
import { scrollToSection } from "@/lib/scroll";

const fade = (delay) => ({
  initial: { opacity: 0, y: 22 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="relative isolate flex min-h-[100svh] items-center overflow-hidden pb-20 pt-32 lg:pb-28 lg:pt-36"
  >
    <div className="pointer-events-none absolute inset-0 -z-10">
      <div className="absolute inset-0 bg-[radial-gradient(120%_90%_at_72%_18%,hsl(var(--navy-800))_0%,hsl(var(--navy-950))_58%,hsl(var(--ink))_100%)]" />
      <div className="absolute inset-y-0 right-0 w-full opacity-[0.3] sm:opacity-[0.4] lg:w-[72%] lg:opacity-[0.55]">
        <div className="h-full w-full [mask-image:linear-gradient(to_right,transparent,black_38%,black_88%,transparent)]">
          <HeroWorld />
        </div>
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,hsl(var(--navy-950)/0.92),hsl(var(--navy-950)/0.45)_52%,transparent)]" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-[linear-gradient(to_top,hsl(var(--navy-950)),transparent)]" />
    </div>

    <div className="shell relative">
      <motion.p {...fade(0.05)} className="eyebrow">
        Montaire Group Limited — Hong Kong
      </motion.p>

      <motion.h1
        {...fade(0.15)}
        className="display mt-8 max-w-4xl text-[2.6rem] leading-[0.95] text-offwhite sm:text-6xl lg:text-[5.25rem]"
      >
        <span className="block">{HERO.headline[0]}</span>
        <span className="block text-mist/90">{HERO.headline[1]}</span>
      </motion.h1>

      <motion.div {...fade(0.3)} className="mt-10 max-w-2xl space-y-5">
        {HERO.paragraphs.map((text) => (
          <p key={text} className="text-sm leading-relaxed text-mist sm:text-base">
            {text}
          </p>
        ))}
      </motion.div>

      <motion.div {...fade(0.45)} className="mt-12 flex flex-wrap items-center gap-4">
        <PrimaryButton
          data-testid="hero-explore-group"
          onClick={() => scrollToSection("group")}
        >
          Explore our group
        </PrimaryButton>
        <GhostButton
          data-testid="hero-get-in-touch"
          onClick={() => scrollToSection("contact")}
        >
          Get in touch
        </GhostButton>
      </motion.div>

      <motion.div {...fade(0.6)} className="mt-16 lg:mt-24">
        <div className="hairline max-w-3xl" />
        <p
          className="label-mono mt-5 text-mist/80"
          data-testid="hero-supporting-line"
        >
          {HERO.supportingLine}
        </p>
      </motion.div>
    </div>
  </section>
);
